import { atom } from "jotai";
import { z } from "zod";

import {
  DESCRIPTION_MIN_CHARS,
  DESCRIPTION_MAX_CHARS,
  nodeDescription,
  renderAnnotationNodesSetter,
} from "../tour";

import { JotaiTool } from "../../index";

const parameters = z.object({
  header: z
    .string()
    .describe(
      "A clear, descriptive header for the explanation in sentence case",
    ),
  description: z
    .string()
    .min(DESCRIPTION_MIN_CHARS)
    .max(DESCRIPTION_MAX_CHARS)
    .describe(
      "A detailed explanation of what this node does and its role in the workflow",
    ),
  displayMessage: z
    .string()
    .optional()
    .describe(
      "Short 3-5 word friendly message describing what you're doing, like 'Explaining the node...'",
    ),
});

export const explainNodeAtom = atom<JotaiTool<z.infer<typeof parameters>>>(
  () => {
    return {
      name: "explain_node",
      description: nodeDescription(
        DESCRIPTION_MIN_CHARS,
        DESCRIPTION_MAX_CHARS,
      ),
      parameters,
      execute: atom(null, async (_get, set, { args, reactFlowInstance }) => {
        const { header, description } = args;
        set(renderAnnotationNodesSetter, {
          rawTourStepsData: [
            {
              header,
              description,
              parentId: "", // Will be resolved in renderAnnotationNodesSetter from nodeIdToExplainAtom
              stepNumber: 1,
            },
          ],
          reactFlowInstance,
        });

        return {
          content: [
            {
              type: "text",
              text: "Explanation created for the step! The annotation shows details about this node's purpose and role in your workflow.",
            },
          ],
        };
      }),
    };
  },
);
explainNodeAtom.debugLabel = "explainNodeAtom";
